export function generateReservationId() {
  const currentDate = new Date().toISOString().slice(0, 10).replace(/-/g, '');
  const randomNumbers = Math.floor(100 + Math.random() * 900);
  const id = `RSRV${currentDate}${randomNumbers}`;
  return id;
}
